import React from 'react';
import PropTypes from 'prop-types';
import CheckBoxAttribute from 'components/Fields/CheckBoxAttribute';
import TextAttribute from 'components/Fields/TextAttribute';
import InputContainer from 'components/InputContainer';
import { DIRECTIONS } from 'utils/constants';
import { generateHTMLIdFromKeyPath } from 'utils/idUtils';
import DirectionButton from '../components/DirectionButton';

const TableRow = ({ disableShouldDisplay, id, idx, keyPath, totalRows, uiState, values, ...props }) => {
  let LabelInput = values.shouldDisplay ? (
    <InputContainer
      keyPath={[...keyPath, 'options', id, 'label']}
      uiState={uiState.label || {}}
    >
      <TextAttribute
        keyPath={[...keyPath, 'options', id, 'label']}
        onFieldValueChange={props.onChangeOptionLabel}
        onFieldUIStateChange={props.onFieldUIStateChange}
        value={values.label}
        id={`${id}_option-label`}
      />
    </InputContainer>
  ) : null;

  if (!Object.keys(values).length) {
    LabelInput = <span className="alert alert-danger">This field has been removed from SalesForce and is no longer valid.</span>;
  }

  return (
    <tr>
      <td className="align-middle">
        <CheckBoxAttribute
          disabled={disableShouldDisplay}
          value={values.shouldDisplay}
          keyPath={[...keyPath, 'options', id, 'shouldDisplay']}
          onCheckBoxChange={props.onChangeShouldDisplay}
          className="position-relative"
        />
      </td>
      <td className="align-middle">{values.value}</td>
      <td className="align-middle">
        {LabelInput}
      </td>
      <td className="align-middle">
        <div className="float-right">
          <DirectionButton
            direction={DIRECTIONS.UP}
            id={generateHTMLIdFromKeyPath([...keyPath, 'options', id, DIRECTIONS.UP])}
            onClickHandler={() => props.onReorderDropdown([...keyPath, 'optionsOrder'], id, DIRECTIONS.UP)}
            disabled={idx === 0}
          />
          <DirectionButton
            direction={DIRECTIONS.DOWN}
            id={generateHTMLIdFromKeyPath([...keyPath, 'options', id, DIRECTIONS.DOWN])}
            onClickHandler={() => props.onReorderDropdown([...keyPath, 'optionsOrder'], id, DIRECTIONS.DOWN)}
            disabled={idx === totalRows - 1}
          />
        </div>
      </td>
    </tr>
  );
};

TableRow.propTypes = {
  disableShouldDisplay: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  idx: PropTypes.number.isRequired,
  keyPath: PropTypes.array.isRequired,
  onChangeOptionLabel: PropTypes.func.isRequired,
  onChangeShouldDisplay: PropTypes.func.isRequired,
  onReorderDropdown: PropTypes.func.isRequired,
  onFieldUIStateChange: PropTypes.func.isRequired,
  totalRows: PropTypes.number.isRequired,
  uiState: PropTypes.object.isRequired,
  values: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    shouldDisplay: PropTypes.bool.isRequired,
  }).isRequired,
};

export default TableRow;
